import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import useIntegrationLayer from 'src/util/hook/useIntegrationLayer';
import keys from './locale/keys.json';

const { hostAppTranslations } = useIntegrationLayer();

// op-web substitutes the key itself when a translation is missing; dropping those
// entries lets the bundled English default show instead of a raw txt_ key.
const resolvedHostAppTranslations = Object.fromEntries(
  Object.entries(hostAppTranslations || {}).filter(([key, value]) => value !== key),
);

const translations = {
  ...keys,
  ...resolvedHostAppTranslations,
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translations,
      },
    },
    fallbackLng: 'en',
    debug: true,

    ns: ['translations'],
    defaultNS: 'translations',
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
